import createVueComponent from '../createVueComponent';

const Slash = createVueComponent('SlashIcon', [
  ['path', { d: 'M22 2 2 22', key: 'y4kqgn' }],
]);

export default Slash;
